import { ColDef } from "ag-grid-community";
import { AutoGroupColumnDefInnerRenderer } from "@/components/pages/commtiments/common/components/AutoGroupColumnDefInnerRenderer";

export const commitmentsGridDefaultColDef: ColDef = {
  unSortIcon: true,
  minWidth: 150,
  filter: "agMultiColumnFilter",
  enableRowGroup: true,
  valueGetter: ({ node, data, colDef }) => {
    if (node?.group) {
      return "";
    }

    return data ? data[colDef.field!] : "Unknown";
  },
};

export const commitmentsGridWrapperStyles = {
  border: 1,
  borderRadius: 2,
  "& .ag-root-wrapper": { borderRadius: 2 },
  borderColor: "grey.300",
};

export const autoGroupColumnDef: ColDef = {
  minWidth: 250,
  pinned: "left",
  sortable: false,
  filter: false,
  enableRowGroup: false,
  suppressMovable: true,
  headerName: "Grouped by",
  cellRendererParams: { innerRenderer: AutoGroupColumnDefInnerRenderer },
};
